import { Tooltip, Popover } from 'bootstrap'

const popoverInstances = new WeakMap()

export const tooltip = {
  mounted(el) {
    const tooltip = new Tooltip(el)
  }
}

export const popoverr = {
  mounted(el) {
    const popover = new Popover(el)
    popoverInstances.set(el, popover)
  },
  unmounted(el) {
    const popover = popoverInstances.get(el)

    if (popover) {
      popover.dispose()
      popoverInstances.delete(el)
    }
  }
}